// extracted by mini-css-extract-plugin
module.exports = {"root":"_3JAFZDkhYzBDXmA83CGAJp","danger":"vkCcFfqFteTbtBuJkK2UZ","success":"_23-nPlDdlYi3OOfkNophVx","warning":"_37cMR0bvaOrlVyF--bOFCI","info":"_2GnPiMd_z5ySFKT6tfFdEx"};